import React, { useState } from 'react';
import CalcShell from '../CalcShell';

export default function ExponentCalc() {
  const [base, setBase] = useState(2);
  const [exp, setExp] = useState(10);
  const [showWork, setShowWork] = useState(false);
  const val = Math.pow(base, exp);
  return (
    <CalcShell look="cnet" title="Exponent Calculator" subtitle="Compute a raised to the power of b.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Base (a)</label><input type="number" step="any" value={base} onChange={e => setBase(+e.target.value || 0)} data-testid="exp-base"/></div>
          <div className="field"><label>Exponent (b)</label><input type="number" step="any" value={exp} onChange={e => setExp(+e.target.value || 0)} data-testid="exp-exp"/></div>
        </div>
        <div>
          <div className="result-panel"><div className="result-title">{base}<sup>{exp}</sup></div><div className="result-value" data-testid="exp-result">{val.toLocaleString(undefined, { maximumFractionDigits: 8 })}</div></div>
        </div>
      </div>
      <div className="mt-4">
        <button onClick={() => setShowWork(v => !v)} data-testid="exp-show-work-toggle"
          className="text-sm px-4 py-1.5 rounded bg-slate-200 hover:bg-slate-300 text-slate-800 font-medium">
          {showWork ? '− Hide working' : '+ Show working'}
        </button>
        {showWork && (
          <div className="mt-4 p-5 bg-blue-50 border border-blue-100 rounded-xl" data-testid="exp-work-panel">
            <h3 className="text-lg font-bold text-slate-900 mb-3">Step-by-step working</h3>
            <ol className="list-decimal ml-5 space-y-2 text-slate-800 text-[15px] leading-7">
              <li><b>Definition</b>: <span className="font-mono">a<sup>b</sup></span> means multiply a by itself b times.</li>
              {Number.isInteger(exp) && exp >= 0 && exp <= 10 && (
                <li><b>Expansion</b>: <span className="font-mono">{base}<sup>{exp}</sup> = {Array.from({ length: exp }, () => base).join(' × ') || '1'} = {val}</span></li>
              )}
              {exp < 0 && <li><b>Negative exponent</b>: <span className="font-mono">a<sup>−b</sup> = 1 / a<sup>b</sup> = 1 / {Math.pow(base, -exp)} = {val}</span></li>}
              {!Number.isInteger(exp) && <li><b>Fractional exponent</b>: <span className="font-mono">a<sup>b</sup> = e<sup>b·ln(a)</sup> = e<sup>{exp} × {Math.log(base).toFixed(4)}</sup> = {val}</span></li>}
              <li><b>Final</b>: <b className="text-[#4c7b25]">{base}<sup>{exp}</sup> = {val.toLocaleString(undefined, { maximumFractionDigits: 8 })}</b></li>
            </ol>
          </div>
        )}
      </div>
    </CalcShell>
  );
}
